import React, { useState } from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "~/lib/utils";
import { trackEvent } from "~/utils/monitoring";

interface DetailsSectionProps {
  title?: string;
  content: string | React.ReactNode;
  defaultExpanded?: boolean;
}

export function DetailsSection({
  title = "Details",
  content,
  defaultExpanded = false,
}: DetailsSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <details
      className="space-y-3 py-1"
      open={isExpanded}
      onToggle={(e) => {
        const target = e.target as HTMLDetailsElement;
        const newExpandedState = target.open;
        setIsExpanded(newExpandedState);

        trackEvent("analysis_agent_details_section_toggled", {
          is_expanded: newExpandedState,
          section_title: title,
        });

        e.stopPropagation();
      }}
    >
      <summary className="list-none cursor-pointer mb-0 select-none">
        <div className="flex items-center gap-0.5 text-xs text-purple-600">
          <span className="font-medium">{title}</span>
          <ChevronRight
            className={cn(
              "size-4 text-purple-600 transition-transform duration-200",
              isExpanded && "rotate-90"
            )}
          />
        </div>
      </summary>
      <div className="mt-2">
        {typeof content === "string" ? (
          <pre className="text-xs text-gray-800 bg-gray-100 p-3 rounded whitespace-pre-wrap break-words border border-gray-200">
            {content}
          </pre>
        ) : (
          content
        )}
      </div>
    </details>
  );
}
